const formatDate = (date) => date.toISOString().slice(0, 10);

const formatChartDateLabel = (timestamp) => {
  const date = new Date(timestamp);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(-2);
  return `${dd}.${mm}.${yy}`;
};
const getMonthRanges = (fromStr, toStr) => {
  const from = new Date(fromStr);
  const to = new Date(toStr);
  const ranges = [];
  let chunkStart = new Date(from);
  while (chunkStart <= to) {
    const monthEnd = new Date(
      chunkStart.getFullYear(),
      chunkStart.getMonth() + 1,
      0,
    );
    const chunkEnd = monthEnd < to ? monthEnd : to;
    ranges.push({
      from: formatDate(chunkStart),
      to: formatDate(chunkEnd),
    });
    chunkStart = new Date(
      chunkStart.getFullYear(),
      chunkStart.getMonth() + 1,
      1,
    );
  }
  return ranges;
};

const mapWithConcurrency = async (items, concurrency, fn) => {
  const results = new Array(items.length);
  let nextIndex = 0;

  const worker = async () => {
    while (nextIndex < items.length) {
      const currentIndex = nextIndex;
      nextIndex += 1;
      results[currentIndex] = await fn(items[currentIndex], currentIndex);
    }
  };

  const workers = Array(Math.min(concurrency, items.length))
    .fill(null)
    .map(() => worker());

  await Promise.all(workers);
  return results;
};

export { getMonthRanges, mapWithConcurrency, formatChartDateLabel };
